module.exports = __webpack_public_path__ + "img/forest.54b079d3.png";